"use strict";
// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * PlumbingWorld-3.0
 * PlumbingWorld API
 *
 * Contact: jspencer@juliusspencer.co.nz
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.OrderStatusToJSON = exports.OrderStatusFromJSONTyped = exports.OrderStatusFromJSON = exports.OrderStatus = void 0;
/**
 *
 * @export
 * @enum {string}
 */
var OrderStatus;
(function (OrderStatus) {
    OrderStatus["RECEIVED"] = "received";
    OrderStatus["SENT_TO_PROSTIX"] = "sent_to_prostix";
    OrderStatus["RETRY_ERP"] = "retry_erp";
    OrderStatus["FAILED"] = "failed";
    OrderStatus["SENT_TO_STORE"] = "sent_to_store";
    OrderStatus["RETRY_EMAIL_STORE"] = "retry_email_store";
    OrderStatus["PICKUP"] = "pickup";
    OrderStatus["DESPATCHED"] = "despatched";
    OrderStatus["DELIVERY"] = "delivery";
    OrderStatus["BACKORDERED"] = "backordered";
    OrderStatus["CONTACTUS"] = "contactus";
    OrderStatus["RELEASED"] = "released";
    OrderStatus["DELETED"] = "deleted";
    OrderStatus["SENT_TO_INTEGRATION"] = "sent_to_integration";
    OrderStatus["FAILED_INTEGRATION"] = "failed_integration";
    OrderStatus["RETRY_INTEGRATION"] = "retry_integration";
    OrderStatus["SENT_TO_SALES_COORDINATOR"] = "sent_to_sales_coordinator";
    OrderStatus["RETRY_SALES_COORDINATOR"] = "retry_sales_coordinator";
    OrderStatus["INTERIM_ORDER_PENDING_INVOICE"] = "interim_order_pending_invoice";
    OrderStatus["PICKED_IN_D365"] = "picked_in_d365";
    OrderStatus["PARTIALLY_SENT_TO_ERP"] = "partially_sent_to_erp";
    OrderStatus["PARTIALLY_UPDATED_IN_ERP"] = "partially_updated_in_erp";
    OrderStatus["FAILED_TO_UPDATE_IN_ERP"] = "failed_to_update_in_erp";
    OrderStatus["FAILED_PARTIALLY_SENT_TO_ERP"] = "failed_partially_sent_to_erp";
    OrderStatus["MANUALLY_PROCESSED"] = "manually_processed";
})(OrderStatus = exports.OrderStatus || (exports.OrderStatus = {}));
function OrderStatusFromJSON(json) {
    return OrderStatusFromJSONTyped(json, false);
}
exports.OrderStatusFromJSON = OrderStatusFromJSON;
function OrderStatusFromJSONTyped(json, ignoreDiscriminator) {
    return json;
}
exports.OrderStatusFromJSONTyped = OrderStatusFromJSONTyped;
function OrderStatusToJSON(value) {
    return value;
}
exports.OrderStatusToJSON = OrderStatusToJSON;
